import { types } from 'mobx-state-tree';


const SWIMMING_POOL_TYPES = {
    IN_GROUND_CONCRETE: 'inground-concrete',
    IN_GROUND_FIBREGLASS: 'inground-fibre-glass',
    IN_GROUND_VINYL: 'inground-vinyl',
    ABOVE_GROUND: 'above-ground',
    ABOVE_GROUND_FIBREGLASS: 'above-ground-fibre-glass',
    NONE: 'none',
    UNKNOWN: 'unknown',
};

const SwimmingPoolTypeEnum = types.enumeration('SwimmingPoolType', Object.values(SWIMMING_POOL_TYPES));

export {
    SwimmingPoolTypeEnum,
};
export default SWIMMING_POOL_TYPES;
